import { defineStore } from 'pinia';
import useEventsBus from '@/utils/eventbus';
import { useStorage } from '@vueuse/core';
import api from '@/http';
import { ref } from 'vue';

const { gEmit } = useEventsBus();

type Company = {
  value: string;
  name: string;
};

export const useReferenceStore = defineStore('reference', {
  state: () => ({
    filterData: useStorage('filterData', {
      companyId: '0',
      unitId: '0',
      departmentId: '0',
      employeeLevel: ''
    }),

    companies: useStorage('refCompanyList',  ref<Company[]>([])),
    units: useStorage('refUnitList', []),
    departments: useStorage('refDepartmentList', []),
    companyIsLoading: false,
    unitIsLoading: false,
    departmentIsLoading: false,
  }),
  actions: {
    applyFilter(payload: any) {
      this.filterData = {
        ...payload
      };
    },
    setCompany(payload: any) {
      this.companies = payload;
    },
    async getCompanyList() {
      if (this.companyIsLoading === true) return;
      this.companyIsLoading = true;
      try {
        const response = await api.get(`/admin/ref/company-list`);
        if (response && response.data) {
          let companies = [];
          companies = response.data.data.map((item: any) => ({
            value: item.id,
            name: item.nama_perusahaan
          }));
          this.companies = companies;
        }
      } catch (error: any) {
        // userInfoIsLoading.value = false;
        if (error && error.response) {
          gEmit('showMessage', 'success', 'error.error', 'error.' + error?.response?.data?.message);
        }
        //   console.error(error);
      } finally {
        this.companyIsLoading = false;
      }
    },
    // setUnit(payload: any) {
    //   this.units = payload;
    // },
    // setDepartment(payload: any) {
    //   this.departments = payload;
    // }
  }
});
